import React from 'react'
import { Pill } from '@myxplor/ui'

import RecordDisplayList from '../../../ui/record-display-list'

const PaymentBadges = ({ record }) => <Pill>{record.PaymentOrRefund}</Pill>

const PaymentsList = ({ records, filtering = false }) => (
  <RecordDisplayList
    name="Payment"
    records={records}
    filtering={filtering}
    recordBadgesComponent={PaymentBadges}
    showRaw
    level1={[
      {
        key: 'PaymentType',
        label: 'Payment type',
      },
      {
        key: 'RemittanceDescription',
        label: 'Remittance description',
      },
      {
        key: 'DatePaid',
        label: 'Date paid',
      },
      {
        key: 'GSTInclusiveAmount',
        label: 'Amount (inc GST)',
      },
    ]}
    level2={[
      {
        key: 'GSTExclusiveAmount',
        label: 'GST exclusive amount',
      },
      {
        key: 'PaymentType',
        label: 'Payment type',
      },
      {
        key: 'OrganisationInvoiceNumber',
        label: 'Organisation invoice number',
      },
      {
        key: 'ProcessingDate',
        label: 'Processing date',
      },
    ]}
  />
)

export default PaymentsList



// WEBPACK FOOTER //
// ./src/payments/details/views/list.jsx